///<reference path="../students/components/add-student/add-student.component.ts"/>
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { DivisionService } from '../../../../services/divisions/division.service';
import { LightboxModule } from 'ngx-lightbox';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { SchoolYearService } from '../../../../services/schoool-year/school-year.service';
import { SchoolYearConceptComponent } from './school-year-concept.component';
import { EditProfessionalConceptModule } from './edit-professional-concept/edit-professional-concept.module';
import { PrintShiftComponent } from './print-shift/print-shift.component';

const routes = [
    {
        path: 'pages/management/schoolyearconcept',
        component: SchoolYearConceptComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        SchoolYearConceptComponent,
        PrintShiftComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        LightboxModule,
        EditProfessionalConceptModule
    ],
    exports: [
        SchoolYearConceptComponent
    ],
    entryComponents: [
        PrintShiftComponent
    ],
    providers: [
        SchoolYearService,
        DivisionService
    ]
})

export class SchoolYearConceptModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/professional-concept/school-year-concept.module.ts